import SectionHeading from "./SectionHeading";
import { debunks, evidenceDossiers } from "@/mocks/debunks";

export default function DebunkSection() {
  return (
    <section id="debunk" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="辟谣专区 · 证据梳理"
          title="已证伪的，我们永久留档"
          desc="辟谣要点与证据链一并公开，避免同一黑料换个标题再传一遍时无人对证。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="lg:col-span-3 space-y-4">
            {debunks.map((d) => (
              <article
                key={d.title}
                className="rounded-lg border-l-4 border-accent-500 bg-background-100/70 p-5 md:p-6"
              >
                <div className="flex items-center gap-2 text-xs text-foreground-600">
                  <span className="inline-flex items-center gap-1 text-accent-700 font-semibold">
                    <i className="ri-close-circle-line"></i>
                    已辟谣
                  </span>
                  <span>{d.date}</span>
                </div>
                <h3 className="mt-2 font-heading text-base md:text-lg font-bold text-foreground-950">
                  {d.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
                  <span className="font-medium text-foreground-900">流传说法：</span>
                  {d.claim}
                </p>
                <p className="mt-1.5 text-sm text-foreground-700 leading-relaxed">
                  <span className="font-medium text-primary-700">核实事实：</span>
                  {d.fact}
                </p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {d.tags.map((t) => (
                    <span
                      key={t}
                      className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-xs"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </article>
            ))}
          </div>

          <aside className="lg:col-span-2">
            <div className="rounded-lg bg-background-100/70 border border-background-200 p-6 md:p-7 h-full">
              <div className="flex items-center gap-2 text-accent-700 font-semibold text-sm">
                <i className="ri-focus-3-line"></i>
                证据梳理
              </div>
              <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950">
                一份结论背后
              </h3>
              <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
                我们不只看结论，更看重可回溯的证据链。以下四类材料构成每条结论的核查依据：
              </p>

              <ul className="mt-5 space-y-3">
                {evidenceDossiers.map((e) => (
                  <li
                    key={e.title}
                    className="flex items-start gap-3 rounded-md bg-background-50 border border-background-200 p-3.5"
                  >
                    <span className="w-9 h-9 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center shrink-0">
                      <i className={`${e.icon} text-lg`}></i>
                    </span>
                    <div>
                      <h4 className="text-sm font-bold text-foreground-900">{e.title}</h4>
                      <p className="mt-0.5 text-xs text-foreground-600 leading-relaxed">{e.note}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}